import React from 'react'
import { findArray } from 'helpers/utils'
import Label from "components/general/Label"
import SportCode from "components/common/SportCode"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare, faCamera } from "@fortawesome/free-solid-svg-icons";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { ColumnRankOws, ColumnBib, ColumnName, ColumnNoc, ColumnResultOWS, ColumnDifferenceOws, ColumnExpander } from "components/common/TableColumns"

export function ColumnIntermediateRankOws({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderRank',
    status = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankIntermediate',
            Cell: (props) => {
                let row = props.cell.row.original
                let val = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })?.er_rank
                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value

                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'OTL')
                        ? val && photo === undefined
                            ? val
                            : photo === 'P' && status !== true
                                ? <><FontAwesomeIcon icon={faCamera} /></>
                                : val
                        : row.resultType === 'REL' || row.resultType === 'IRM_TIME' || row.resultType === 'IRM'
                            ? row?.resultIrm
                            : ''
                )
            },

        }
    )
}

export function ColumnIntermediateDistanceOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderIntermediate',
    config = '',

}) {

    return (
        {
            Header: <Label data={label} />,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'ResultIntermediateDistanceOws',
            Cell: (props) => {
                let row = props.cell.row.original
                const { mirs_discipline } = useUrlFriendlyToParameters()

                let values = row?.extendedResults?.filter(er => er.er_value !== undefined && er.er_code === 'INTERMEDIATE' && er.er_type === 'PROGRESS')
                values?.sort((a, b) => (b.er_pos === 'F' ? 100 : b.er_pos) - (a.er_pos === 'F' ? 100 : a.er_pos))
                let currentPos = 0;
                if (Array.isArray(values) && values.length > 0)
                    currentPos = values[0]?.er_pos;

                let item = findArray(config, { code: ['INTERMEDIATE'], pos: [currentPos] })

                let distance = item?.value

                let type = findArray(item?.extension, { code: ['NAME'] })?.value
                let lap = (type !== undefined)
                    ? <> <SportCode code={type} discipline={mirs_discipline} entity="@IntPtType" /> - </>
                    : ''

                let header = item.pos === 'F' ? <Label data="HeaderFinish" /> : <> {lap}{distance}<Label data='LabelKm' /> </>

                return (
                    (row.resultType !== 'IRM')
                        ? isNaN(Number(distance))
                            ? distance
                            : header
                        : ''
                )
            },


        }
    )
}

export function ColumnIntermediateTimeOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTime',
}) {

    return (
        {
            Header: <Label data={label} />,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateTime',
            Cell: (props) => {
                let row = props.cell.row.original

                let values = row?.extendedResults?.filter(er => er.er_value !== undefined && er.er_code === 'INTERMEDIATE' && er.er_type === 'PROGRESS')
                values?.sort((a, b) => (b.er_pos === 'F' ? 100 : b.er_pos) - (a.er_pos === 'F' ? 100 : a.er_pos))
                let currentPos = 0
                if (Array.isArray(values) && values.length > 0)
                    currentPos = values[0]?.er_pos;

                let rowExtendedResult = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [currentPos] })

                let card = 0
                if (Array.isArray(values) && values.length > 0) {
                    values.forEach(i => {
                        if (i?.extensions !== undefined)
                            card = i?.extensions[0]?.ere_value;
                    });
                }
                let intermediateTime = rowExtendedResult?.er_value

                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value

                let flagNoData = row?.extendedResults?.find(er => er.er_code === 'INTERMEDIATE' && er.er_type === 'PROGRESS')?.extensions?.find(ere => ere.ere_code === 'FLAG')?.ere_value
                
                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'OTL')
                        ? photo === undefined
                            ? card === 'Y' || flagNoData === 'Y'
                                ? <><FontAwesomeIcon icon={faSquare} color='yellow' /> {intermediateTime}</>
                                : intermediateTime
                            : photo === 'P'
                                ? ''
                                : intermediateTime
                        : ''

                )

            },


        }
    )
}

export function ColumnIntermediateDiffOws({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind',
}) {
    return (
        {
            Header: <Label data={label} />,
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateDiff',
            Cell: (props) => {
                let row = props.cell.row.original

                let intermediate = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [row.currentSplit] })

                let diff = intermediate?.er_diff

                let rank = intermediate?.er_rank

                let photo = findArray(row.extendedResults, { er_code: ['PHOTO'] })?.er_value

                return (
                    (row.resultType !== 'IRM' && row.resultIrm !== 'REL' && row.resultIrm !== 'IRM_TIME')
                        ? photo == undefined
                            ? rank === '1'
                                ? ''
                                : diff
                            : photo === 'P'
                                ? ''
                                : rank == '1'
                                    ? ''
                                    : diff
                        : ''
                )

            },


        }
    )
}

export function TableColumnsLive(columnsAdded) {
    return (
        [
            ColumnIntermediateRankOws({}),
            ColumnBib({ label: 'HeaderBibNo' }),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediateDistanceOws({ config: columnsAdded }),
            ColumnIntermediateTimeOws({}),
            ColumnIntermediateDiffOws({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsLiveSM(columnsAdded) {
    return (
        [
            ColumnIntermediateRankOws({ disableSort: true }),
            ColumnBib({ disableSort: true, label: 'HeaderBibNo' }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnIntermediateDistanceOws({ label: 'Label_intermediate', config: columnsAdded }),
            ColumnIntermediateTimeOws({}),
            ColumnExpander({ type: 'alwaysTrue' })
        ]
    )
}

export function TableColumnsFinish() {

    return (
        [
            ColumnRankOws({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResultOWS({ label: "HeaderTime" }),
            ColumnDifferenceOws({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}

export function TableColumnsFinishSM() {

    return (
        [
            ColumnRankOws({ disableSort: true }),
            ColumnNoc({}),
            ColumnName({ disableSort: true }),
            ColumnResultOWS({ label: "HeaderTime" }),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}